import { invokeApi } from "../Utils/InvokeApi";
import { invokeApi2 } from "../Utils/InvokeApi2";
import { invokeApi3 } from "../Utils/InvokeApi3";

export const deleteAdmin = async (id) => {
  const reqObj = {
    path: `/user/admin/delete/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const deletePermision = async (id) => {
  const reqObj = {
    path: `/permission/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const deleteCategory = async (id) => {
  const reqObj = {
    path: `/delete-product-categories/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const deletePk = async (id) => {
  const reqObj = {
    path: `/delete-pk/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const deleteGift = async (id) => {
  const reqObj = {
    path: `/gift/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const deleteFamilyRule = async (id) => {
  const reqObj = {
    path: `/del-family-rule/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const deleteTag = async (id) => {
  const reqObj = {
    path: `/delete-live-stream-tag/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const deleteStreamTag = async (id) => {
  const reqObj = {
    path: `/delete-assign-stream-tag/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const deleteProducts = async (id) => {
  const reqObj = {
    path: `/delete-product/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const deleteAgency = async (id) => {
  const reqObj = {
    path: `/agency/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const deleteSenderLevel = async (id) => {
  const reqObj = {
    path: `/del-sender-level-info/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const deleteHostLevel = async (id) => {
  const reqObj = {
    path: `/del-host-level-info/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const deleteDiamondPackage = async (id) => {
  const reqObj = {
    path: `/package/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const deleteFamily = async (id) => {
  const reqObj = {
    path: `/family/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const DeleteBubbleImage = async (id) => {
  const reqObj = {
    path: `/delete-text-bubble/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const DeleteBannerImage = async (id) => {
  const reqObj = {
    path: `/image/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const DeleteSpecialRid = async (id) => {
  const reqObj = {
    path: `/delete-special-rid/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const DeleteProfileTag = async (id) => {
  const reqObj = {
    path: `/delete-profile-tag/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const DeleteProfileUserTag = async (id) => {
  const reqObj = {
    path: `/delete-profile-user-tag/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const deleteMerchant = async (id) => {
  const reqObj = {
    path: `/remove-merchant/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const deleteWithdrawPayment = async (id) => {
  const reqObj = {
    path: `/withdraw-payment-method/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const deleteSvip = async (id) => {
  const reqObj = {
    path: `/vip/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const DeleteBannerData = async (id) => {
  const reqObj = {
    path: `/delete-banner/${id}`,
    method: "DELETE",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
